import { render, staticRenderFns } from "./paymentConfirm.vue?vue&type=template&id=4ebbb326&scoped=true&"
import script from "./paymentConfirm.vue?vue&type=script&lang=js&"
export * from "./paymentConfirm.vue?vue&type=script&lang=js&"
import style0 from "./paymentConfirm.vue?vue&type=style&index=0&id=4ebbb326&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebbb326",
  null
  
)

export default component.exports